import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

type Props = {
  markdown: string;
};

export const MarkdownView = ({ markdown }: Props) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        fontFamily: 'MB Corpo S Text',
        color: isDark ? '#E0E0E0' : '#222222',
        overflowY: 'auto',
        lineHeight: 1.6,
        fontSize: '1rem',
        '& h1, h2, h3, h4': {
          color: isDark ? '#FFFFFF' : '#222',
          fontWeight: 600,
        },
        '& code': {
          backgroundColor: isDark ? '#2e2e2e' : '#e0e0e0',
          padding: '0.2em 0.4em',
          borderRadius: 4,
          fontFamily: 'monospace',
          fontSize: '0.85em',
        },
        '& pre': {
          backgroundColor: isDark ? '#121212' : '#1e1e1e',
          color: '#fafafa',
          padding: theme.spacing(2),
          borderRadius: 2,
          overflow: 'auto',
        },
        '& a': {
          color: '#00ADEF',
          textDecoration: 'underline',
        },
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: theme.spacing(2),
        },
        '& th, & td': {
          border: `1px solid ${isDark ? '#444' : '#ddd'}`,
          padding: theme.spacing(1),
          textAlign: 'left',
        },
        '& th': {
          backgroundColor: isDark ? '#2a2a2a' : '#eee',
        },
        '& ul, & ol': {
          pl: 3,
        },
        '& blockquote': {
          borderLeft: '4px solid #00ADEF',
          backgroundColor: isDark ? '#002B3F' : '#f0faff',
          padding: theme.spacing(1.5),
          fontStyle: 'italic',
        },
      }}
    >
      <ReactMarkdown
        children={markdown}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          a: ({ href, children, ...props }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
        }}
      />
    </Box>
  );
};
